import { CSSProperties, FC } from 'react';
import { withStyles } from '../../../utils/utils';
import styles from './MaterialSymbol.module.scss';

const cn = withStyles(styles);

// https://fonts.google.com/icons
export type MaterialSymbolIcon =
  | 'article'
  | 'content_copy'
  | 'cancel'
  | 'delete'
  | 'open_in_new'
  | 'add'
  | 'call_received'
  | 'close'
  | 'close_small'
  | 'download'
  | 'do_not_disturb_on'
  | 'warning'
  | 'flag'
  | 'description'
  | 'check'
  | 'calendar_today'
  | 'hourglass'
  | 'remove'
  | 'send'
  | 'keyboard_arrow_down'
  | 'keyboard_arrow_up'
  | 'keyboard_arrow_right'
  | 'zoom_out_map'
  | 'zoom_in_map'
  | 'table_rows'
  | 'lan'
  | 'more_horiz'
  | 'cached'
  | 'unfold_more'
  | 'file_copy'
  | 'pending'
  | 'file_export'
  | 'chevron_left'
  | 'chevron_right'
  | 'check_circle'
  | 'stop_circle'
  | 'filter_alt'
  | 'arrow_circle_left'
  | 'arrow_circle_right'
  | 'pending'
  | 'language'
  | 'do_not_disturb_on'
  | 'auto_awesome'
  | 'auto_graph'
  | 'language'
  | 'lock'
  | 'timeline'
  | 'group'
  | 'list_alt'
  | 'home'
  | 'pending'
  | 'check_circle'
  | 'cancel'
  | 'people'
  | 'storefront'
  | 'info'
  | 'more_horiz'
  | 'person'
  | 'search'
  | 'switch_left'
  | 'switch_right'
  | 'pending'
  | 'horizontal_rule'
  | 'menu'
  | 'progress_activity'
  | 'edit'
  | 'language'
  | 'currency_exchange'
  | 'error'
  | 'info'
  | 'language'
  | 'lock'
  | 'replay'
  | 'fiber_manual_record'
  | 'account_circle'
  | 'logout'
  | 'account_balance'
  | 'credit_card'
  | 'visibility'
  | 'receipt_long'
  | 'arrow_back'
  | 'bolt'
  | 'check_indeterminate_small'
  | 'publish'
  | 'visibility'
  | 'schedule'
  | 'task_alt'
  | 'visibility_off'
  | 'gavel'
  | 'storefront'
  | 'power'
  | 'school'
  | 'gpp_good'
  | 'sports_tennis'
  | 'local_mall'
  | 'payments'
  | 'cell_tower'
  | 'construction'
  | 'grass'
  | 'medical_services'
  | 'real_estate_agent'
  | 'groups'
  | 'commute'
  | 'manage_search'
  | 'block'
  | 'download_2';

type MaterialSymbolProps = {
  icon: MaterialSymbolIcon;
  size?: CSSProperties['fontSize'];
  color?: CSSProperties['color'];
  weight?: CSSProperties['fontWeight'];
  fillAmount?: number;
  className?: string;
  family?: 'outlined' | 'rounded';
};

const MaterialSymbol: FC<MaterialSymbolProps> = ({
  icon,
  size,
  color,
  weight,
  family = 'rounded',
  className,
  fillAmount,
}) => {
  return (
    <span
      className={cn('material-symbols', `material-symbols-${family}`, className)}
      style={{
        color,
        '--weight': weight,
        '--fontSize': size,
        '--fillAmount': fillAmount,
      }}
    >
      {icon}
    </span>
  );
};

export default MaterialSymbol;
